// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_TgZ","cls2":"LettersModal-cls2_bE1 LettersModal-cls1_TgZ"};